!function () {
  function a(b, c, d) {
    function e(g, h) {
      if (!c[g]) {
        if (!b[g]) {
          var i = "function" == typeof require && require;
          if (!h && i) return i(g, !0);
          if (f) return f(g, !0);
          var j = new Error("Cannot find module '" + g + "'");
          throw j.code = "MODULE_NOT_FOUND", j;
        }

        var k = c[g] = {
          exports: {}
        };
        b[g][0].call(k.exports, function (a) {
          return e(b[g][1][a] || a);
        }, k, k.exports, a, b, c, d);
      }

      return c[g].exports;
    }

    for (var f = "function" == typeof require && require, g = 0; g < d.length; g++) {
      e(d[g]);
    }

    return e;
  }

  return a;
}()({
  1: [function (a, b, c) {
    "use strict";

    function d(a, b) {
      if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
    }

    function e(a, b) {
      return {
        until: 1e3 * parseInt(a.timeStamps[parseInt(b[0], 32)], 32),
        offset: a.offsets[parseInt(b[1], 32)],
        isdst: !!parseInt(b[2], 10)
      };
    }

    function f(a) {
      for (var b = [], c = 0; c < a.length;) {
        b.push([a[c], a[c + 1], a[c + 2]]), c += 3;
      }

      return b;
    }

    function g(a, b) {
      var c = b.split(","),
          d = c.length;
      if (d % 3 != 0) throw new Error("wrong length of history Array, must be multiple of 3");
      var g = f(c).map(function (b) {
        return e(a, b);
      });
      if (d / 3 !== g.length) throw new Error("failed to harvest all data!!");
      return g;
    }

    function h(a) {
      var b = this.globalSpace;

      if (b && b.Intl._metaZoneData) {
        var c = b.Intl._metaZoneData,
            d = null;

        if (a.forEach(function (a) {
          c.get(a) && (d = c.get(a));
        }), d) {
          var e = c.get();
          a.forEach(function (a) {
            c.get(a) || (e[a] = d);
          });
        }
      }
    }

    function i(a) {
      var b = this;
      if (!(a && Array.isArray(a.zoneDefs) && Array.isArray(a.timeStamps) && Array.isArray(a.offsets))) throw new Error("loadTimeZoneData: rejected packedTzData, packedTzData is not in right shape.");
      var c = {
        timeStamps: a.timeStamps,
        offsets: a.offsets
      };
      a.zoneDefs.forEach(function (a) {
        var d = a.split("||"),
            e = d[0].split(","),
            f = d[1],
            h = g(c, f);
        e.forEach(function (a) {
          b.value[a] = h;
        }), b.enrichMetaZoneMapWithEquivalentZones(e);
      });
    }

    function j(a, b) {
      var c = b.split("|"),
          d = function d(b) {
        return a[parseInt(b, 32)];
      };

      return {
        long: {
          standard: c[0].split(",").filter(function (a) {
            return !!a;
          }).map(d).join(""),
          daylight: c[1].split(",").filter(function (a) {
            return !!a;
          }).map(d).join("")
        },
        short: {
          standard: c[2].split(",").filter(function (a) {
            return !!a;
          }).map(d).join(""),
          daylight: c[3].split(",").filter(function (a) {
            return !!a;
          }).map(d).join("")
        }
      };
    }

    function k(a) {
      var b = this;
      if (!a || !a.locales || !Array.isArray(a.zoneNameIndex)) throw new Error("loadLocaleData: rejected data, data is not in right shape.");

      var c = function c(b) {
        return j(a.zoneNameIndex, b);
      };

      Object.keys(a.locales).forEach(function (d) {
        var e = a.locales[d].metazone;
        Object.keys(e).forEach(function (a) {
          e[a] = c(e[a]);
        });
        var f = a.locales[d].zone;
        Object.keys(f).forEach(function (a) {
          f[a] = c(f[a]);
        }), b.value[d] = a.locales[d];
      }), Object.keys(a.locales).forEach(function (a) {
        for (var c = a.split("-"), d = 0; d < c.length - 1; d++) {
          var e = c.slice(0, c.length - d - 1).join("-");
          b.value[e] || (b.value[e] = b.value[a]);
        }
      });
    }

    function l(a) {
      if (this.get(a)) return this.get(a);

      for (var b = a.split("-"), c = [], d = 0; d < b.length - 1; d++) {
        c.push(b.slice(0, b.length - d - 1).join("-"));
      }

      for (var e = 0; e < c.length; e++) {
        if (this.get(c[e])) return this.get(c[e]);
      }
    }

    function m(a) {
      a.Intl && (a.Intl._metaZoneData = new n(), a.Intl._localeData = new n(k, {
        getLocale: l
      }), a.Intl._timeZoneData = new n(i, {
        enrichMetaZoneMapWithEquivalentZones: h.bind({
          globalSpace: a
        })
      }));
    }

    Object.defineProperty(c, "__esModule", {
      value: !0
    }), c.default = m;

    var n = function a(b, c) {
      var e = this;
      d(this, a), this.value = {}, this.load = b || function (a) {
        this.value = a;
      }, c && Object.keys(c).forEach(function (a) {
        return e[a] = c[a];
      }), this.get = function (a) {
        return void 0 === a ? this.value : this.value[a];
      };
    };
  }, {}],
  2: [function (a, b, c) {
    "use strict";

    function d(a, b, c) {
      var d = a < 0 ? "-" : "+",
          e = Math.floor(Math.abs(a / 60)),
          f = Math.abs(a % 60),
          g = Intl.NumberFormat(c, {
        minimumIntegerDigits: b ? 1 : 2
      }).format(e),
          h = Intl.NumberFormat(c, {
        minimumIntegerDigits: 2
      }).format(f);
      return 0 === a ? "" : (b && 0 === f && (h = ""), d + g + (h ? ":" : "") + h);
    }

    function e(a, b, c) {
      if (!Array.isArray(a)) return null;
      if (1 === a.length) return a[0].mzone;
      var d = -1e3 * Math.pow(2, 31),
          e = 1e3 * Math.pow(2, 31),
          f = null;
      return a.forEach(function (a) {
        var g = a.from ? new Date(a.from + c).getTime() : d,
            h = a.to ? new Date(a.to + c).getTime() : e;
        g <= b && b <= h && (f = a.mzone);
      }), f;
    }

    function f(a, b, c) {
      if (!a && c.long) {
        if (b && c.long.daylight) return c.long.daylight;
        if (!b && c.long.standard) return c.long.standard;
      } else if (c.short) {
        if (b && c.short.daylight) return c.short.daylight;
        if (!b && c.short.standard) return c.short.standard;
      }

      return !1;
    }

    function g(a, b) {
      var c = b.getTime(),
          d = a.reduce(function (a, b) {
        return b.until >= c && null === a ? b : a;
      }, null);
      return d || a[a.length - 1];
    }

    function h(a) {
      var b = a.locale,
          c = a.ianaTimeZone,
          g = a.offset,
          h = a.isdst,
          i = a.isShort,
          j = a.timeStamp,
          k = e(Intl._metaZoneData.get(c), j, d(g)),
          l = Intl._localeData.getLocale(b),
          m = k && l && l.metazone[k],
          n = l && l.zone && l.zone[c];

      if (n && f(i, h, n)) return f(i, h, n);
      if (m && f(i, h, m)) return f(i, h, m);
      if (l && l.gmtFormat && g) l.gmtFormat.replace("{0}", d(g, i, b));else if (l && l.gmtZeroFormat && !g) return l.gmtZeroFormat;
      return g && ["GMT", d(g, i, b)].join("") || "GMT";
    }

    Object.defineProperty(c, "__esModule", {
      value: !0
    });

    var i = function i(a) {
      var b = {};
      return function (c) {
        if (void 0 !== b[c]) return b[c];

        try {
          new a.Intl._DateTimeFormat("en", {
            timeZone: c
          }), b[c] = !0;
        } catch (a) {
          b[c] = !1;
        }

        return b[c];
      };
    };

    c.buildCachedCheckTimeZoneSupport = i, c.getTimeZoneOffsetInfo = g, c.getZoneNameForLocale = h;
  }, {}],
  3: [function (a, b, c) {
    "use strict";

    function d(a, b, c) {
      null === a && (a = Function.prototype);
      var e = Object.getOwnPropertyDescriptor(a, b);

      if (void 0 === e) {
        var f = Object.getPrototypeOf(a);
        if (null === f) return;
        return d(f, b, c);
      }

      if ("value" in e) return e.value;
      var g = e.get;
      if (void 0 !== g) return g.call(c);
    }

    function e(a) {
      return Object.getPrototypeOf ? Object.getPrototypeOf(a) : a.__proto__;
    }

    function f(a, b) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : (a.__proto__ = b, a);
    }

    function g(a) {
      return -1 !== Function.toString.call(a).indexOf("[native code]");
    }

    function h(a) {
      function b() {
        var b = e(this).constructor,
            c = [null];
        c.push.apply(c, arguments);
        var d = Function.bind.apply(a, c),
            g = new d();
        return b && f(g, b.prototype), g;
      }

      return g(a) ? (b.prototype = Object.create(a.prototype, {
        constructor: {
          value: b,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), f(b, a)) : a;
    }

    function i(a, b) {
      if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === b ? "undefined" : k(b)));
      a.prototype = Object.create(b && b.prototype, {
        constructor: {
          value: a,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), b && f(a, b);
    }

    function j(a) {
      function b(a, f) {
        if (!(this instanceof b)) return new b(a, f);
        var h = void 0,
            i = f && f.timeZone || "UTC";
        if (void 0 === f) return h = k.call(this, a, f), h.formatToParts && (h._nativeObject = new k(a, f)), h;
        if (g(i)) return h = k.call(this, a, f), h.formatToParts && (h._nativeObject = new k(a, f)), h;

        var l = c._timeZoneData.get(i);

        if (!l) throw new RangeError("invalid time zone in DateTimeFormat():  " + i);
        var m = j(f);
        m.timeZone = "UTC", h = k.call(this, a, m);
        var n = d(e(b.prototype), "resolvedOptions", h),
            o = n.call(h).locale;
        if (!(void 0 === f.timeZoneName || c._localeData.getLocale(o) && Intl._metaZoneData.get(i))) throw new RangeError('unsupported value "' + f.timeZoneName + '" for timeZone ' + i + ". requires locale data for " + o);
        return h._dateTimeFormatPolyfill = {
          optionTimeZone: i,
          optionTimeZoneName: f.timeZoneName,
          timeZoneData: l
        }, h;
      }

      if (a.Intl && a.Intl.DateTimeFormat && !a.Intl._DateTimeFormatTimeZone) {
        var c = a.Intl,
            f = a.Date,
            g = (0, l.buildCachedCheckTimeZoneSupport)(a),
            j = function j(a) {
          return JSON.parse(JSON.stringify(a));
        },
            k = h(c.DateTimeFormat);

        c._DateTimeFormat = k, c._DateTimeFormatTimeZone = {
          checkTimeZoneSupport: g
        }, i(b, k), Object.defineProperty(b.prototype, "format", {
          configurable: !0,
          value: function value(a) {
            var c = d(e(b.prototype), "format", this),
                f = d(e(b.prototype), "resolvedOptions", this);
            if (!this._dateTimeFormatPolyfill) return c.call(this, a);
            null !== a && void 0 !== a || (a = new Date()), a instanceof Date || (a = new Date(a));
            var g = this._dateTimeFormatPolyfill,
                h = (0, l.getTimeZoneOffsetInfo)(g.timeZoneData, a),
                i = 6e4 * h.offset,
                j = new Date(a.getTime() + i),
                k = c.call(this, j),
                m = f.call(this).locale;

            if (void 0 !== g.optionTimeZoneName) {
              var n = "short" === g.optionTimeZoneName,
                  o = (0, l.getZoneNameForLocale)({
                locale: m,
                ianaTimeZone: g.optionTimeZone,
                isdst: h.isdst,
                offset: h.offset,
                timeStamp: a.getTime(),
                isShort: n
              }),
                  p = (0, l.getZoneNameForLocale)({
                locale: m,
                ianaTimeZone: "UTC",
                isdst: !1,
                offset: 0,
                timeStamp: a.getTime(),
                isShort: n
              });
              return k.indexOf(p) < 0 ? k.trim() + " " + o : k.replace(p, o);
            }

            return k;
          }
        });
        var m = d(e(b.prototype), "formatToParts", this);
        m && Object.defineProperty(b.prototype, "formatToParts", {
          configurable: !0,
          value: function value(a) {
            var c = d(e(b.prototype), "resolvedOptions", this);
            if (!this._dateTimeFormatPolyfill && this._nativeObject) return this._nativeObject.formatToParts(a);
            null !== a && void 0 !== a || (a = new Date()), a instanceof Date || (a = new Date(a));
            var f = this._dateTimeFormatPolyfill,
                g = (0, l.getTimeZoneOffsetInfo)(f.timeZoneData, a),
                h = 6e4 * g.offset,
                i = new Date(a.getTime() + h),
                j = m.call(this, i),
                k = c.call(this).locale;

            if (void 0 !== f.optionTimeZoneName) {
              var n = "short" === f.optionTimeZoneName,
                  o = (0, l.getZoneNameForLocale)({
                locale: k,
                ianaTimeZone: f.optionTimeZone,
                isdst: g.isdst,
                offset: g.offset,
                timeStamp: a.getTime(),
                isShort: n
              }),
                  p = j.map(function (a) {
                return a.type;
              }).indexOf("timeZoneName");
              p >= 0 && (j[p] = {
                type: "timeZoneName",
                value: o
              });
            }

            return j;
          }
        }), Object.defineProperty(b.prototype, "resolvedOptions", {
          writable: !0,
          configurable: !0,
          value: function value() {
            var a = d(e(b.prototype), "resolvedOptions", this);

            if (this._dateTimeFormatPolyfill) {
              var c = j(a.call(this));
              return c.timeZone = this._dateTimeFormatPolyfill.optionTimeZone, c;
            }

            return a.call(this);
          }
        }), c.DateTimeFormat = b, f.prototype.toLocaleString = function (a, b) {
          var d = {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
          };
          return void 0 === b && (b = j(d)), void 0 === b.day && void 0 === b.month && void 0 === b.year && void 0 === b.hour && void 0 === b.minute && void 0 === b.second && (b = j(b), b.day = d.day, b.month = d.month, b.year = d.year, b.hour = d.hour, b.minute = d.minute, b.second = d.second), new c.DateTimeFormat(a, b).format(this);
        }, f.prototype.toLocaleDateString = function (a, b) {
          var d = {
            day: "numeric",
            month: "numeric",
            year: "numeric"
          };
          return void 0 === b && (b = j(d)), void 0 === b.day && void 0 === b.month && void 0 === b.year && (b = j(b), b.day = d.day, b.month = d.month, b.year = d.year), new c.DateTimeFormat(a, b).format(this);
        }, f.prototype.toLocaleTimeString = function (a, b) {
          var d = {
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
          };
          return void 0 === b && (b = j(d)), void 0 === b.hour && void 0 === b.minute && void 0 === b.second && (b = j(b), b.hour = d.hour, b.minute = d.minute, b.second = d.second), new c.DateTimeFormat(a, b).format(this);
        };
      }
    }

    Object.defineProperty(c, "__esModule", {
      value: !0
    });
    var k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
      return typeof a;
    } : function (a) {
      return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    };
    c.default = j;
    var l = a("./lookup-utill.js");
  }, {
    "./lookup-utill.js": 2
  }],
  4: [function (a, b, c) {
    (function (c) {
      var d = void 0 !== c && "[object global]" === {}.toString.call(c) ? c : window;
      a("./code/polyfill.js").default(d), a("./code/data-loader.js").default(d), b.exports = d.Intl.DateTimeFormat;
    }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  }, {
    "./code/data-loader.js": 1,
    "./code/polyfill.js": 3
  }]
}, {}, [4]);